export const REQUIRED = 'Required';
export const IN_REVIEW = 'In Review';
export const FAILED = 'Failed';
export const PASSED = 'Passed';

export const KYC_STATUS = {
  AWAITING_DATA: REQUIRED,
  DATA_PROVIDED: IN_REVIEW,
  PENDING: IN_REVIEW,
  INVALID_DATA: FAILED,
  RETRY_LIMIT_REACHED: FAILED,
  FAILED,
  PASSED,
};

export const FAKE_VERIFICATIONS = [
  'Identity Verification',
  'Company Verification',
  'Passport Verification',
  'Bank Account Verification',
];
